import { Supplier } from 'services/api/entities/crm/suppliers'
import { EntityDescriptor } from '.'
import { formatBusinessUserCsv } from './common'

const formatSupplierUserCsv = formatBusinessUserCsv

export const suppliers: EntityDescriptor<Supplier> = {
  format: formatSupplierUserCsv,
}
